export const SUCCESS = 'success';
export const ERROR = 'error';

export const AVAILABILITY_BUSY_ID = 'e5e6a412-8779-4403-a580-47c04a75d580';
export const AVAILABILITY_AVAILABLE_ID = '5ef41aad-1f1c-478f-98e4-19f13cb1ac52';
export const AVAILABILITY_ARCHIEVED_ID = '14002be1-02c9-4f38-b8f0-9bfc15aecac1';

export const GENDER_MALE = 'M';
export const GENDER_FEMALE = 'F';
export const GENDER_UNDEFINED = 'U';